module.exports = __webpack_public_path__ + "img/color_script_thumb.05f6664f.jpg";